module.exports = __webpack_public_path__ + "img/machine_handle_with_sleeve.prt.f252af9e.jpg";